import ajax from "@/scripts/common/ajax";
import { createValidator } from "./validation/validator";
import { toggleSubmit, showFormMessages } from "@/scripts/components/form/form";
import { fireEvent, trackGoogleAnalytics } from "@/scripts/common/util";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";

export const setupAjaxForm = (form) => {
  const validator = form.dataset.formValidate !== undefined && createValidator(form);
  const hideOnSubmit = form.dataset.formHideOnSubmit !== undefined;
  const disableAutoHideMessage = form.dataset.formNoHideMessage !== undefined;

  const handleMessages = (messages, success) => {
    const formMessages = [];

    messages.forEach((message) => {
      if (message.fieldName) {
        validator.addFieldError(form.elements[message.fieldName], message.message);
      } else {
        formMessages.push(message);
      }
    });

    const autoHide = success && !hideOnSubmit && !disableAutoHideMessage;

    showFormMessages(form, formMessages, success, autoHide);
  };

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    toggleSubmit(form);

    if (validator) {
      const result = validator.validateForm();
      const firstError = form.querySelector(".has-error");

      if (!result.isValid) {
        toggleSubmit(form);

        if (firstError) {
          scrollToIfNeeded(firstError, 32);
        }

        return;
      }
    }

    const formData = new FormData(form);

    try {
      const res = await ajax.post(form.action, { body: formData }).json();

      if (res.success) {
        if (res.ga) {
          res.ga.forEach((event) => trackGoogleAnalytics(event));
        }

        form.querySelectorAll(".file-input-placeholder.filled").forEach((el) => {
          el.classList.remove("filled");
          el.textContent = null;
        });

        form.reset();

        fireEvent("form:submit", form);
      }

      if (res.messages) {
        handleMessages(res.messages, res.success);
      }

      if (res instanceof Array) {
        handleMessages(res, false);
      }
    } catch (error) {
      console.error(error);
      showFormMessages(form, [{ message: "Sorry, there was a problem with your submission" }]);
    } finally {
      toggleSubmit(form);
    }
  });
};
